import { config } from "../../config";
import axios from "axios";
import moment from "moment";

import { Profile, Gender, NewProfile } from '../../entity/authentication/profile';
import { User } from '../../entity/authentication/user';
import { Address } from '../../entity/location/address';
import { State } from '../../entity/location/state';
import { AddressTransformer } from '../transformers/address';
import { LocalStorage } from '@/data/localstorage';
import { BaseService } from '../base';

export class ProfilerService extends BaseService{
    //SCMT 2.0
    // 17-07-2024 updatedNewProfileForUser funtion start

    async updatedNewProfileForUser (newprofile : NewProfile, user: User ) {
        let userInfo = {
            userId: user.id
        }
        let profileInfo: any = {
            firstName: newprofile.firstName,
            email: newprofile.email
        }
        let address = newprofile.address
        if (address){
            let addressInfo = {
                gstInd: address.gstInd,
                state: {
                    code: address.state.code                
                },
                gstnumber: address.gstNumber
            }
            profileInfo = {...profileInfo, ...addressInfo}
        }
        profileInfo = {...userInfo, ...profileInfo} 
        await axios.put(config.api.host + "/accounts/" + user.id + "/profile", {
            data: profileInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }

    //updatedNewProfileForUser funtion end
    
    async updatedProfileForUser(profile: Profile, user: User): Promise<void> {
        let userInfo = {
            userId: user.id
        }
        let profileInfo: any = {
            firstName: profile.firstName,
            lastName: profile.lastName,
            gender: {
                code: profile.gender.code
            },
            DOB: moment(profile.dob).format("YYYY-MM-DD"),
            email: profile.email
        }
        let address = profile.address
        if (address){
            let addressInfo = {
                addressLine1: address.line1,
                addressLine2: address.line2,
                addressLine3: address.line3,                
                city: address.city,
                state: {
                    code: address.state.code                
                },
                pincode: address.zipcode
            }
            profileInfo = {...profileInfo, ...addressInfo}
        }
        profileInfo = {...userInfo, ...profileInfo}     
        await axios.put(config.api.host + "/accounts/" + user.id + "/profile", {
            data: profileInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }

    async profileOfUser(user: User): Promise<Profile> {        
        let response = await axios.get(config.api.host + "/accounts/" + user.id + "/profile", {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        })
        let profileInfo: any = response.data.data
        let profile = new Profile(
            profileInfo.firstName,
            profileInfo.lastName,
            new Gender(profileInfo.gender.code, profileInfo.gender.description),
            moment(profileInfo.DOB, "YYYY-MM-DD").toDate(),
            profileInfo.mobile,
            profileInfo.gstInd,
            profileInfo.gstNumber,
            new AddressTransformer().transform(profileInfo),
            profileInfo.email
            
        )
        return Promise.resolve(profile)
    }

    async profileOfCustomer(customer: User): Promise<Profile> {  
        let userId = window.localStorage.getItem('user.id');      
        let response = await axios.get(config.api.host + "/accounts/" + userId + "/profile/" + customer.id, {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        })
        let profileInfo: any = response.data.data
        let profile = new Profile(
            profileInfo.firstName,
            profileInfo.lastName,
            new Gender(profileInfo.gender.code, profileInfo.gender.description),
            moment(profileInfo.DOB, "YYYY-MM-DD").toDate(),
            profileInfo.mobile,
            profileInfo.gstInd,
            profileInfo.gstNumber,
            new AddressTransformer().transform(profileInfo),
            profileInfo.email
            
        )
        return Promise.resolve(profile)
    }

    async genders(): Promise<Gender[]> {
        let response = await axios.get(config.api.host + "/genders");
        this.checkNetworkError(response);
        let gendersInfos: any[] = response.data.data
        let genders: Gender[] = []
        gendersInfos.forEach(genderInfo => {
            genders.push(new Gender(genderInfo.code, genderInfo.description))
        });
        return Promise.resolve(genders)
    }

    // Delete user account
    async deleteUserAccount(user: User): Promise<void> {
        const profileInfo = {
            userId : user.id
        }
        const response = await axios.put(config.api.host + "/accounts" + "/" + user.id + "/deleteUserAccount" , {
            data: profileInfo
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        new LocalStorage().clear()
        return Promise.resolve()
    }
}